module.exports = __webpack_public_path__ + "img/home_main.69a47673.png";